export function getSortedCategoriesWithSubcategories(categories) {
  return categories
    .map((category) => ({
      ...category,
      subcategories: Array.isArray(category.subcategories)
        ? [...category.subcategories].sort((a, b) => a.title.localeCompare(b.title, undefined, { sensitivity: 'base' }))
        : [],
    }))
    .sort((a, b) => a.title.localeCompare(b.title, undefined, { sensitivity: 'base' }))
}
